module.exports = __webpack_public_path__ + "img/Configure-background-blue.64cc31bd.svg";